module.exports = __webpack_public_path__ + "img/tree-05-a-trunk.d140ce72.png";